module.exports = __webpack_public_path__ + "img/game.e6c11495.svg";